export * from "./StandoutText";
